import functions from '../../services/functions'

const logger = function (store) {
  store.subscribe(mutation => {
    if (mutation.type !== 'ADD_LOG') {
      if (mutation.type.indexOf('SUCCESS') > -1) {
        if (
          mutation.type.indexOf('MYPROFILE') > -1 ||
          mutation.type.indexOf('MYSITES') > -1 ||
          mutation.type.indexOf('CAMERA_THUMBNAILVIDEOS') > -1
        ) {
          store.commit('ADD_LOG', {
            status: 'success',
            message: functions.capitalizeFirstLetter((mutation.type + '').replace(/_/g, ' '))
          })
        } else if (mutation.type.indexOf('SITE_CAMERA_EVENT') > -1) {
          store.commit('ADD_LOG', {
            status: 'success',
            message: 'New event on ' + store.getters.camera(mutation.payload.event.cameraId).name
          })
        }
      } else if (mutation.type.indexOf('FAILURE') > -1) {
        if (
          mutation.type.indexOf('MYPROFILE') > -1 ||
          mutation.type.indexOf('MYSITES') > -1
        ) {
          store.commit('ADD_LOG', {
            status: 'error',
            message: functions.capitalizeFirstLetter((mutation.type + '').replace(/_/g, ' '))
          })
        }
      } else if (mutation.type.indexOf('MQTT') > -1) {
        if (mutation.type.indexOf('DISCONNECTED') > -1) {
          store.commit('ADD_LOG', {
            status: 'error',
            message: 'Disconnected from the CHeKT cloud'
          })
        } else if (mutation.type.indexOf('CONNECTED') > -1) {
          store.commit('ADD_LOG', {
            status: 'info',
            message: 'Connected to the CHeKT cloud'
          })
        } else if (mutation.type.indexOf('SITE_SUBSCRIBE') > -1) {
          store.commit('ADD_LOG', {
            status: 'info',
            message: 'Start listening to realtime event for ' + store.getters.site(mutation.payload).name
          })
        } else if (mutation.type.indexOf('SITE_UNSUBSCRIBE') > -1) {
          store.commit('ADD_LOG', {
            status: 'info',
            message: 'Stop listening to realtime event for ' + store.getters.site(mutation.payload).name
          })
        }
      } else if (mutation.type.indexOf('SELECT_SITE') > -1) {
        store.commit('ADD_LOG', {
          status: 'info',
          message: store.getters.site(mutation.payload).name + ' is selected'
        })
      } else if (mutation.type.indexOf('INTERNET') > -1) {
        if (mutation.type.indexOf('DISCONNECTED') > -1) {
          store.commit('ADD_LOG', {
            status: 'error',
            message: 'Internet disconnected'
          })
        } else if (mutation.type.indexOf('CONNECTED') > -1) {
          store.commit('ADD_LOG', {
            status: 'success',
            message: 'Internet connected'
          })
        }
      } else if (mutation.type.indexOf('API_RATELIMIT') > -1) {
        if (mutation.type.indexOf('LOCKED') > -1) {
          store.commit('ADD_LOG', {
            status: 'error',
            message: 'Too many request. Your api requests are blocked for 1 minute.'
          })
        } else if (mutation.type.indexOf('UNLOCKED') > -1) {
          store.commit('ADD_LOG', {
            status: 'success',
            message: 'Your api requests are now unblocked.'
          })
        }
      }
    }
  })
}

export default logger



// WEBPACK FOOTER //
// ./src/store/plugins/logger.js